export default "/images/average_bill_value.png?73d8ebdf6691840e49bdcf2e312f392b";